/**
 * @generated SignedSource<<dc27de015e7e7fdc2bcf242db576513f>>
 * @relayHash a19e6ddab57746e0969d8f0d99d80ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af443a2a1915dedc51686b64500e31400c16154f18abe6a8a0ec9f2bfc6e906f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeleteProjectModalQuery } from './DeleteProjectModalQuery.graphql';

const node: PreloadableConcreteRequest<DeleteProjectModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "af443a2a1915dedc51686b64500e31400c16154f18abe6a8a0ec9f2bfc6e906f",
    "metadata": {},
    "name": "DeleteProjectModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
